import { motion } from "framer-motion";
import { IMAGES, BUSINESS } from "../../lib/site";

const lines = ["Elevating", "the Art of", "Every Texture"];

const lineVariants = {
  hidden: { y: "110%" },
  show: (i) => ({ y: "0%", transition: { duration: 1, ease: [0.22, 1, 0.36, 1], delay: 0.4 + i * 0.12 } }),
};

export const Hero = ({ onBook }) => {
  return (
    <section id="top" className="relative min-h-screen flex items-end overflow-hidden">
      <motion.div
        initial={{ scale: 1.15 }}
        animate={{ scale: 1 }}
        transition={{ duration: 2.2, ease: [0.22, 1, 0.36, 1] }}
        className="absolute inset-0"
      >
        <img src={IMAGES.hero} alt="Barbershop interior" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/60" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-[#0A0A0A]/40" />
      </motion.div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-6 md:px-10 pb-20 md:pb-28">
        <motion.p
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.3, duration: 1 }}
          className="text-xs uppercase tracking-[0.35em] text-[#C9A24B] mb-6"
        >
          Hair Cut Solutions · {BUSINESS.city}
        </motion.p>

        <h1 className="font-serif-display font-light leading-[0.92] tracking-tight text-[#FAFAFA] text-5xl sm:text-7xl lg:text-8xl">
          {lines.map((line, i) => (
            <span key={i} className="block overflow-hidden">
              <motion.span custom={i} variants={lineVariants} initial="hidden" animate="show" className="block">
                {i === 2 ? <span className="gold-gradient-text italic">{line}</span> : line}
              </motion.span>
            </span>
          ))}
        </h1>

        <motion.div
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 1.3, duration: 0.9 }}
          className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-6"
        >
          <p className="max-w-md text-sm md:text-base text-[#8A8A8A] font-light leading-relaxed">
            A Calgary grooming studio for every community — with deep expertise across all hair textures. Precision cuts, honest craft, booked in seconds.
          </p>
          <button
            onClick={onBook}
            data-testid="hero-book-btn"
            className="group shrink-0 inline-flex items-center gap-3 px-8 py-4 bg-[#C9A24B] text-black text-xs uppercase tracking-[0.2em] font-semibold rounded-sm hover:scale-105 hover:bg-[#d9b463] transition-transform transition-colors duration-300 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-white"
          >
            Book Appointment
            <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
          </button>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.8, duration: 1 }}
        className="absolute bottom-8 right-6 md:right-10 z-10 hidden md:flex items-center gap-2 text-[10px] uppercase tracking-[0.3em] text-[#8A8A8A]"
      >
        <span className="w-8 h-px bg-[#C9A24B]" /> Scroll
      </motion.div>
    </section>
  );
};
